import React, {useState} from "react";
import {isMobile} from "../../../../../../../helpers/Mobile"
import styles from "./Description.module.scss";
import documentTextIcon from "assets/images/document-text.svg";
import receiptEditIcon from "assets/images/receipt-edit.svg";
import barcodeIcon from "assets/images/barcode.svg";
import tagUserIcon from "assets/images/tag-user.svg";
import calendarIcon from "assets/images/calendar-icon.svg";
import i18n from "i18n";
import { capitalize, translateOrder } from "helpers/utils/utils_general";


export const OrderDetailDescriptionPanel = (props) => {
    const [ toggleOpen, setToggleOpen ] = useState(false);

    if (!props.order){
        return <div></div>;
    }

    return (
        <div className={styles["order-detail-description-panel-container"]}>

            <div className={styles[`order-detail-description-panel-title`]} onClick={() => setToggleOpen(!toggleOpen)}>
            {capitalize(i18n.t("description"))}
                {(isMobile) &&
                    <i name="icon-chevron" className={`icon-chevron ${styles["order-detail-description-panel-chevron"]} ${toggleOpen ? styles["open"] : ""} `}></i>
                }
            </div>

                {(!isMobile || toggleOpen) && <React.Fragment>
                    {props.order.map( item => {
                        const value = translateOrder(item.value);
                        const getIconSrc = (title) => {
                            if (title === i18n.t("reason").toLowerCase()) return receiptEditIcon;
                            if (title === i18n.t("order.type").toLowerCase()) return documentTextIcon;
                            if (title === i18n.t("order.number").toLowerCase()) return barcodeIcon;
                            if (title === i18n.t("owner").toLowerCase()) return tagUserIcon;
                            if (title === i18n.t("destination").toLowerCase()) return tagUserIcon;
                            if (title === i18n.t("creation.date").toLowerCase()) return calendarIcon;
                            return null;
                        };

                        const iconSrc = getIconSrc(item.title?.toLowerCase());

                        return item.value && (<div className={styles["order-detail-description-panel-section"]} key={item.title}>
                          {iconSrc && (
                            <div className={styles["section-icon-wrapper"]} >
                              <img src={iconSrc} alt={`${item.title} icon`} className={styles["section-icon"]}/>
                            </div>
                          )}
                          <div>
                                    <div className={styles["order-detail-description-panel-section-title"]}>{item.title}</div>
                                    <div className={styles["order-detail-description-panel-section-content"]}>{value}</div>
                                </div>
                                </div>)
                    })}
                </React.Fragment>}

        </div>
    );

}

export default OrderDetailDescriptionPanel;